export default __webpack_public_path__ + "static/media/backArrowGray.c6b22d0a.svg";